// React
import React from 'react'
import PropTypes from 'prop-types'

// Components
import BTime from 'ui/blocks/TimeButton'
import H2 from 'ui/elements/H2'
import P from 'ui/elements/P'
import { Button } from './Button'

// Shared
import { getColumnsCount } from './utils'
import { useTranslation } from 'shared/utils/useTranslation'

export const Content = ({ maxHeight, width = '250px', handleClose = () => {}, ...props }) => {
  const { t } = useTranslation('user')

  const columns = getColumnsCount()

  const handleSelect = (value) => {
    props.onSelect(value)

    handleClose()
  }

  if (!props.options?.length) {
    return (
      <BTime maxHeight={maxHeight || '300px'}>
        <BTime.Cleanstate width={width}>
          <H2>{t(props.translate ? 'user.store.no_time_available_header' : 'common.time_picker.no_options_header')}</H2>
          <P>{t(props.translate ? 'user.store.no_time_available_text' : 'common.time_picker.no_options_body')}</P>
        </BTime.Cleanstate>
      </BTime>
    )
  }

  if (props.useAMOrPM) {
    const { am, pm } = props.options.reduce(
      (acc, timeslot) => {
        if (timeslot.label.includes('AM')) {
          acc.am.push(timeslot)
        }

        if (timeslot.label.includes('PM')) {
          acc.pm.push(timeslot)
        }

        return acc
      },
      { am: [], pm: [] }
    )

    return (
      <BTime data-tid={props['data-tid']} maxHeight={maxHeight || '300px'}>
        {am.length > 0 && (
          <BTime.Section>
            <BTime.Header>AM</BTime.Header>
            <BTime.Timeslots columns={props.columns || columns}>
              {am.map((timeslot) => {
                const label = timeslot.label.replace(/\s?(AM|PM)/gi, '')

                return <Button key={timeslot.value} {...props} data={timeslot} label={label} onSelect={handleSelect} />
              })}
            </BTime.Timeslots>
          </BTime.Section>
        )}
        {pm.length > 0 && (
          <BTime.Section>
            <BTime.Header>PM</BTime.Header>
            <BTime.Timeslots columns={props.columns || columns}>
              {pm.map((timeslot) => {
                const label = timeslot.label.replace(/\s?(AM|PM)/gi, '')

                return <Button key={timeslot.value} {...props} data={timeslot} label={label} onSelect={handleSelect} />
              })}
            </BTime.Timeslots>
          </BTime.Section>
        )}
      </BTime>
    )
  }

  return (
    <BTime data-tid={props['data-tid']} maxHeight={maxHeight || '300px'}>
      <BTime.Timeslots columns={props.columns || columns}>
        {props.options.map((timeslot) => (
          <Button key={timeslot.value} {...props} data={timeslot} label={timeslot.label} onSelect={handleSelect} />
        ))}
      </BTime.Timeslots>
    </BTime>
  )
}

Content.propTypes = {
  'field': PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date), PropTypes.object]),
    onChange: PropTypes.func,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
    onInvalid: PropTypes.func,
    /** Custom validation function should return invalid key or true
     * ex. validate = (date) => 'HH'
     */
    validate: PropTypes.func
  }),
  'columns': PropTypes.number,
  'useAMOrPM': PropTypes.bool,
  'options': PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.any,
      value: PropTypes.string
    })
  ),
  'onSelect': PropTypes.func,
  'availabilityMode': PropTypes.string,
  'translate': PropTypes.bool,
  'maxHeight': PropTypes.string,
  'width': PropTypes.string,
  'data-tid': PropTypes.string,
  // Function passed from the popover to close it programmatically
  'handleClose': PropTypes.func
}
